export default __webpack_public_path__ + "static/media/google-gmail.6383c443.svg";